var exports = {
  "iE": "xaee3c4fa--a6b435--wrapper",
  "ou": "xaee3c4fa--a6b435--searching-query",
  "A1": "xaee3c4fa--a6b435--_active",
  "BL": "xaee3c4fa--a6b435--submit-wrapper",
  "Ep": "xaee3c4fa--a6b435--spinner-wrapper",
  "pw": "xaee3c4fa--a6b435--nothing-found-wrapper",
  "ag": "xaee3c4fa--a6b435--searching-results",
};

module.exports = exports;
